import React from 'react';
import PropTypes from 'prop-types';
import { pdiIcons } from 'pages/PDI/utils';

import * as S from './styles';

const CertificateBox = ({ data, handlePreview }) => (
  <S.Container>
    <S.Certificate>
      <S.Icon>{pdiIcons('pdf')}</S.Icon>
      <S.Descriptions>
        <S.CertificateArea title={data?.area || ''}>{data?.area || '--'}</S.CertificateArea>
        <S.CertificateBlock title={data?.bloco || 'Outros certificados'}>{data?.bloco || 'Outros certificados'}</S.CertificateBlock>
        <S.CertificateQuestion title={data?.questao || 'Inserido através do .zip'}>{data?.questao || 'Inserido através do .zip'}</S.CertificateQuestion>
      </S.Descriptions>
    </S.Certificate>
    <S.Actions>
      <S.ViewCertificate onClick={() => handlePreview(data?.base64)}>
        {pdiIcons('view')}
        Ver
      </S.ViewCertificate>
      <S.DownloadCertificate download={`certificado-${data?.questao || 'outros'}`} href={`data:application/pdf;base64,${data?.base64}`}>
        {pdiIcons('download')}
        Download
      </S.DownloadCertificate>
    </S.Actions>
  </S.Container>
);

CertificateBox.propTypes = {
  data: PropTypes.shape({
    area: PropTypes.string,
    bloco: PropTypes.string,
    questao: PropTypes.string,
    certificado: PropTypes.string,
  }).isRequired,
  handlePreview: PropTypes.func.isRequired,
};
export default CertificateBox;
